var Faqs = new (class Faqs extends AbstractModule {

  constructor() {
    super("Faqs");
    this.viewTitle = null
  }

  /**
   * enterState
   * @param  {Conversation} conversation
   * @return {Promise}      true: If the user was able to search in the FAQ
   *                        false: If there was no FAQ
   */
  enterState(conversation) {
    return new Promise((resolve, reject) => {
      if (this.app._faqs_count == 0) resolve(false);
      else {
        Utils.logState(conversation, 'Faq');
        conversation.submitTo('faq');
        conversation.storePromise(resolve, reject, 'faq');
      }
    });
  }

  fetchFaqsQuery(query, smalltalk = true, content_included = false) {
    return Ajax.call('/api/faq', {
            key: this.app._api_key,
            query: query,
            token: this.app._guest_token,
            language: this.app._language,
            smalltalk: smalltalk,
            content_included: content_included
          });
  }

  async fetchFaqQuery(faqId) {
    let faq = await Ajax.call('/api/single_faq', { key: this.app._api_key, id: faqId, token: this.app._guest_token, language: this.app._language, });

    faq.content = faq.content.replace('href=', 'target="_blank" href=');
    return faq;
  }

  fetchFaqs(conversation, query) {
    this.fetchFaqsQuery(query, true, false)
      .then(ajaxData => this._faqCallback(conversation, ajaxData));
  }

  async displayOnView(faqId) {
    let faqView = Views.getByName('faq')

    this.viewTitle            = Wording.loading_button_value
    faqView.syncTitle()

    faqView.element.innerHTML = `
      <div id="slaask-widget-faqs-container" class="slaask-widget-faqs-container slaask-widget-card">
        <div class="slaask-loader-wrapper with-margins">
          <div class="slaask-loader-object slaask-loader-object-color slaask-loader-center" style="border-top-color: ${this.app._window_color}"></div>
        </div>
      </div>
    `;
    let faq                   = await this.fetchFaqQuery(faqId);
    let lastUpdate            = new Date(faq.updated_at).toGMTString();
    lastUpdate                = lastUpdate.replace(/ \d+:\d+:\d+.*/, '');

    this.viewTitle            = faq.title
    faqView.syncTitle()

    faqView.element.innerHTML = `
      <div id="slaask-widget-faqs-container" class="slaask-widget-faqs-container slaask-widget-card">
        <div style="margin-bottom:4px;font-size: 16px!important;color: rgba(0,0,0);">
          ${faq.title}
        </div>
        <div style="margin-bottom:20px;color: rgba(73, 76, 93, 0.7);">
          ${Wording.homepage_helpcenter_last_update}${lastUpdate}
        </div>
        ${faq.content}
      </div>
    `;
  }

  enabled(when) {
    // 0: Offline only
    // 1: Offline and online
    // 2: Never
    if (this.app._faqs_count == 0) return false;
    switch(when) {
      case 'offline':
      case 'either':
        return this.app._start_with_faq == 0 || this.app._start_with_faq == 1;
      case 'online':
      case 'both':
        return this.app._start_with_faq == 1;
      case 'neither':
        return this.app._start_with_faq == 2
    }
    return false;
  }

  _faqCallback(conversation, faqs) {
    if (Object.prototype.toString.call(faqs) == '[object Object]')
      this._faqSmalltalkCallback(conversation, faqs);
    else
      this._faqResponseCallback(conversation, faqs);
  }

  _faqSmalltalkCallback(conversation, faq) {
    conversation.addMessage(new Message(MS.bot, faq.answer));
  }

  _faqResponseCallback(conversation, faqs) {
    if (faqs.length > 0) {

      let faqListMessage = this._getFaqListMessage(faqs);
      let exitMessage    = this._getExitMessage(conversation);

      conversation.addMessage(faqListMessage);
      if (exitMessage)
        conversation.addMessage(exitMessage);

    } else {
      let message = new Message(MS.bot, Wording.md('bot_oops_text'));
      // message.plain_text = Wording.bot_oops_text;
      this._addNextAndAgainToMessage(conversation, message);

      conversation.addMessage(message);
    }
  }

  _getFaqListMessage(faqs) {
    let userFaqsHtml = '';
    for (let i = 0; i < faqs.length; i++) {
      userFaqsHtml += `<div data-id="${faqs[i].objectID}" data-url="${faqs[i].url}" id="slaask-faq-link-${faqs[i].objectID}" class="slaask-faqs-item slaask-btn">${faqs[i].title}</div>`
    }

    let message = new Message(MS.bot);
    message.text = Wording.md('bot_success_text') + userFaqsHtml;
    message.plain_text = Wording.bot_success_text;

    message.addInteraction({
      selector: '.slaask-faqs-item',
      event: 'click',
      handler: e => {
        let faqUrl = Utils.dataSet(e.currentTarget, 'url');
        Views.jumpToViewByName('iframe', faqUrl);
      }
    });

    return message;
  }

  _getExitMessage(conversation) {
    if (conversation.life_span == Conversation.LIFE_SPAN.OFFLINE && !this.app._offline_email_address)
      return null;
    let message = new Message(MS.bot);
    message.text = this.app._bot_email_text;
    message.plain_text = this.app._bot_email_text;
    message.type = "notification";

    this._addNextAndAgainToMessage(conversation, message);

    return message;
  }

  _faqClickButton(conversation) {
    conversation.resolvePromise(true, 'faq');
  }

  _faqTryAgain(message) {
    let temp = document.createElement('div');
    temp.innerHTML = message.text;
    temp.querySelectorAll('.slaask-mandatory-buttons').forEach(x => Utils.removeElement(x));
    message.text = temp.innerHTML;
    message.mandatory_buttons = false;
    Conversations.updateMessage(message);
  }

  _addNextAndAgainToMessage(conversation, message, reverse) {
    let nextTxt = '';
    if (conversation.life_span == Conversation.LIFE_SPAN.ONLINE) nextTxt = Wording.bot_start_button;
    else if (this.app._offline_email_address) nextTxt = Wording.bot_email_button;
    else return false;

    let next = '<div class="slaask-open-email-form slaask-btn">' + nextTxt + '</div>';
    let tryAgain = '<div class="slaask-faq-try-again slaask-btn">' + Wording.faq_try_again + '</div>';
    message.text += `<div class="slaask-mandatory-buttons">${reverse ? next + tryAgain : tryAgain + next}</div>`;

    message.addInteraction({
      selector: '.slaask-open-email-form',
      event: 'click',
      removeButtons: true,
      printResponse: e => e.currentTarget.innerHTML,
      handler: e => {
        this._faqTryAgain(message);
        this._faqClickButton(Conversations.get(message.conv_id));
      }
    });
    message.addInteraction({
      selector: '.slaask-faq-try-again',
      event: 'click',
      printResponse: e => e.currentTarget.innerHTML,
      handler: e => {
        this._faqTryAgain(message);
      }
    });
    message.mandatory_buttons = true;
    return true;
  }
});
